import React, {useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDialogOpen, setViewingUserFriends } from '../../../../store/Actions';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FancyButton } from '../../../common/buttons';
import { FancyTextField } from '../../../common/inputs';
import { MyAvatar } from '../../../common/MyAvatar';
import { deleteUserFriend, friendIsInEvents, storeUserFriend } from '../../../../firebase/Firestore';

export function EditFriend(props) {
    const userFriends = useSelector(state=>state.viewingUserFriends);
    const dialogData = useSelector(state=>state.dialogData);
    const friend = dialogData.friend;
    const [name, setName] = useState(friend.name);
    const dispatch = useDispatch();
    const cancelEdit = () => {
        // 'View Friend' is no longer a dialog — the friend detail page
        // lives in the URL now, so just close the Edit modal in that case
        // and the underlying detail page reappears.
        if(!dialogData.parentDialog || dialogData.parentDialog === 'View Friend'){
            dispatch(setDialogOpen(''));
        } else {
            dispatch(setDialogOpen(dialogData.parentDialog, dialogData));
        }
    }

    const openEditAvatarDialog = async () => {
        const updatedFriend = await saveFriend();
        const editAvatarDialogData = {
            parentDialog: 'Edit Friend', 
            editParentDialog: dialogData.parentDialog,
            listDialog: dialogData.listDialog,
            dialogTitle: 'Update ' + friend.name + '\'s Avatar',
            friend: updatedFriend
        }
        dispatch(setDialogOpen('Update Friend Avatar', editAvatarDialogData))
    }

    const onSave = async ()=>{
        if(!name){
            alert('please enter a name');
            return;
        }
        const updatedFriend = await saveFriend();
        if(!dialogData.parentDialog || dialogData.parentDialog === 'View Friend'){
            // Close so the friend detail page (URL-routed) reappears with the
            // updated name from Redux.
            dispatch(setDialogOpen(''));
        } else {
            dispatch(setDialogOpen(dialogData.parentDialog));
        }
        // Use updatedFriend so eslint's exhaustive-deps doesn't flag the
        // unused binding when this hook is re-formatted in the future.
        void updatedFriend;
    }

    const saveFriend = async () => {
        const updatedFriend = await storeUserFriend(friend.id, {...friend, name});
        dispatch(setViewingUserFriends({...userFriends, [updatedFriend.id]: updatedFriend}));
        return updatedFriend;
    }

    const deleteFriend = async() => {
        if(!window.confirm(`Are you sure you want to delete ${friend.name}?`)) return;
        if(await friendIsInEvents(friend)){
            alert('This friend exists in some of your events');
            return;
        }
        await deleteUserFriend(friend.id);
        const updatedFriends = {...userFriends};
        delete updatedFriends[friend.id];
        dispatch(setViewingUserFriends(updatedFriends));
        dispatch(setDialogOpen(dialogData.listDialog === null ? '' : (dialogData.listDialog || 'Friends')));
    }

    return (
        <>
            <DialogTitle>{dialogData.dialogTitle}</DialogTitle>
            <DialogContent style={{flex:1, width:'400px'}}>
                <div style={{display:'flex', flexDirection:'column'}}>
                    <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                        <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'start'}}>
                            <div style={{fontWeight:600, marginRight:'10px'}}>Avatar</div>
                            <MyAvatar userAccount={{...friend, name}}/>
                        </div>
                        <FancyButton
                            disabled={!name}
                            onClick={openEditAvatarDialog}
                        >
                            Update Avatar
                        </FancyButton>
                    </div>
                    <FancyTextField
                        label="Name"
                        fullWidth
                        style={{marginTop:'20px'}}
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                    />
                </div>
                
            </DialogContent>
            <DialogActions style={{display:'flex', flexDirection:'row', justifyContent:'space-between', padding:'20px', paddingLeft:'24px', paddingRight:'24px'}}>
                <div>
                    {friend.id &&
                        <FancyButton variant="danger" onClick={deleteFriend}>Delete</FancyButton>
                    }
                </div>
                <div style={{display:'flex', gap:'10px'}}>
                    <FancyButton onClick={cancelEdit}>Cancel</FancyButton>
                    <FancyButton variant="dark" onClick={onSave}>Save</FancyButton>
                </div>
            </DialogActions>
        </>
    );
}
